/*
 * NOTE: Add all new feature flags to the list below to:
 *   a) Show all available features in the debug panel for users to toggle.
 *   b) Serve as a single source for all *Non-Server Based* SMEX feature switches
 *      currently available to developers.
 *
 * Please add and remove flags as necessary.
 */

export const DEBUG = {
  name: 'debug',
  forceReload: true,
  requiresValue: false,
  toolTip: 'Reveal all debug options.'
}
export const ENVIRONMENT_OVERRIDE = {
  name: 'environment-override',
  forceReload: true,
  toolTip: 'Choose an environment to get your dependencies from.',
  requiresValue: true
}
export const SOCIAL_MEDIA_ICONS = {
  name: 'social-media-icons',
  forceReload: true,
  toolTip: 'Reveal Social Media Icons feature.',
  requiresValue: false
}

export const ENABLE_PHET = {
  name: 'enable-phet',
  forceReload: true,
  requiresValue: false,
  toolTip: 'Enable PhET integration'
}

export const PHET_LANGUAGES = {
  name: 'phet-languages',
  forceReload: false,
  requiresValue: false,
  toolTip: 'Enables Language selection in PhET Wizard and set Simulations to choosen language'
}

export const UPLOAD_CONTENT_SMEX = {
  name: 'upload-content-smex',
  forceReload: false,
  requiresValue: false,
  toolTip: 'Enables the user to upload lessons to SMEX'
  // team: CDC
  // expiry: none
}

export default [
  DEBUG,
  ENVIRONMENT_OVERRIDE,
  SOCIAL_MEDIA_ICONS,
  ENABLE_PHET,
  PHET_LANGUAGES,
  UPLOAD_CONTENT_SMEX
]
